import { render, staticRenderFns } from "./TrainingRegistrationConfirmation.vue?vue&type=template&id=67630e48&scoped=true&"
import script from "./TrainingRegistrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./TrainingRegistrationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./TrainingRegistrationConfirmation.vue?vue&type=style&index=0&id=67630e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67630e48",
  null
  
)

export default component.exports